import React from 'react';
import PropTypes from 'prop-types';
import { NavLink, useHistory } from 'react-router-dom';

import Routes from 'containers/app/routes';
import { ReactComponent as Logo } from 'svg/min-logo.svg';
import { Row, Col } from 'antd';

import { getRoutePrefix } from 'utils/routes';
import Client from 'containers/app/client';
import { useUserWithRole } from 'hooks/custom-auth';

import User from './user';
import Tokens from './tokens';

import './style.css';

const shouldShowInNav = ({ nav, pub, employer, worker, user, admin }) => {
  const { claims = {} } = user || {};
  const { role = false } = claims;

  if (!nav) return false;
  if (user && pub) return false;
  if (!user && !pub) return false;
  if (admin === true && !claims.admin) return false;
  if (employer && role !== 'isEmployer') return false;
  if (worker && role !== 'isWorker') return false;

  return true;
};

const Header = ({ userType }) => {
  const [user] = useUserWithRole(Client.auth);
  const history = useHistory();

  const handleButtonClick = (e) => {
    if (!user || !user.claims) return;

    e.preventDefault();
    history.push(`${getRoutePrefix(user.claims.role)}/dashboard`);
  };

  return (
    <header id="header">
      <nav className="wrapper">
        <div className="logo">
          <Logo onClick={handleButtonClick} />
        </div>

        <Row className="nav">
          <Col>
            <Tokens />
          </Col>

          {Routes.map(({ name, path, nav, public: pub, ...rest }) => {
            const show = shouldShowInNav({ nav, pub, user, ...rest });
            return show ? (
              <Col key={name} className="navlinks">
                <NavLink to={path}>{name}</NavLink>
              </Col>
            ) : null;
          })}

          {user ? (
            <Col key="booking" className="navlinks">
              <NavLink
                to={`${getRoutePrefix(user.claims.role)}/booking-requests`}
              >
                Booking requests
              </NavLink>
            </Col>
          ) : null}

          <Col>
            <User userType={userType} />
          </Col>
        </Row>
      </nav>
    </header>
  );
};

Header.propTypes = {
  userType: PropTypes.string,
};

Header.defaultProps = {
  userType: '',
};

export default Header;
